import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";

export const Process = ({ t }) => (
  <section id="craft" data-testid="process-section" className="py-16 lg:py-20 bg-white border-y border-[#3E2723]/10">
    <div className="max-w-7xl mx-auto px-6 lg:px-12">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7 }}
        className="max-w-2xl"
      >
        <p className="text-xs font-semibold uppercase tracking-[0.25em] text-[#A67C00] mb-4">
          {t.process.overline}
        </p>
        <h2 className="font-serif font-light text-4xl sm:text-5xl text-[#2D1810] tracking-tight">{t.process.title}</h2>
      </motion.div>

      <div className="mt-10 grid grid-cols-1 md:grid-cols-3 border border-[#3E2723]/15 divide-y md:divide-y-0 md:divide-x divide-[#3E2723]/15">
        {t.process.steps.map((s, i) => (
          <motion.div
            key={s.n}
            initial={{ opacity: 0, y: 32 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.8, delay: i * 0.14, ease: [0.16, 1, 0.3, 1] }}
            data-testid={`process-step-${s.n}`}
            className="group relative p-10 lg:p-12 hover:bg-[#F5F2EC] transition-colors duration-500"
          >
            <div className="absolute top-0 left-0 h-0.5 w-0 bg-[#D4AF37] group-hover:w-full transition-[width] duration-700" />
            <span className="block font-sans font-extralight text-7xl leading-none text-[#2D1810]/15 group-hover:text-[#A67C00]/60 transition-colors duration-500">
              {s.n}
            </span>
            <p className="mt-6 text-[10px] font-semibold uppercase tracking-[0.3em] text-[#A67C00]">
              {t.process.chapter} {s.n}
            </p>
            <h3 className="mt-2 font-serif text-2xl text-[#2D1810]">{s.title}</h3>
            <p className="mt-4 text-sm sm:text-base text-[#3E2723]/70 leading-relaxed">{s.text}</p>
          </motion.div>
        ))}
      </div>

      <motion.div
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.7, delay: 0.3 }}
        className="mt-8"
      >
        <a
          href="#quote"
          data-testid="process-cta"
          className="inline-flex items-center gap-2 bg-[#3E2723] text-[#F5F2EC] px-8 py-4 text-sm font-semibold rounded-sm hover:bg-[#2D1810] hover:-translate-y-1 transition-[transform,background-color] duration-300"
        >
          {t.process.cta}
          <ArrowRight size={16} />
        </a>
      </motion.div>
    </div>
  </section>
);
